<template>
  <nav class="site-header">
    <div
      class="mx-auto flex w-[94%] flex-wrap items-center justify-between px-1 py-3 sm:px-4 sm:py-4"
    >
      <span class="flex items-center">
        <span
          style="cursor: pointer"
          @click="goHome"
          class="self-center text-2xl font-black whitespace-nowrap text-white"
          >AtoZ</span
        >
      </span>
      <button
        @click="isDrop = !isDrop"
        data-collapse-toggle="navbar-default"
        type="button"
        class="inline-flex items-center p-2 w-10 h-10 justify-center text-sm rounded-lg md:hidden text-[#1ec8ff] hover:bg-white/10 focus:outline-none focus:ring-2 focus:ring-[#1ec8ff]/40"
        aria-controls="navbar-default"
        aria-expanded="false"
      >
        <span class="sr-only">Open main menu</span>
        <svg
          class="w-5 h-5"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 17 14"
        >
          <path
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M1 1h15M1 7h15M1 13h15"
          />
        </svg>
      </button>
      <div class="w-full md:block md:w-auto" :class="[{ hidden: isDrop }]" id="navbar-default">
        <ul
          class="mt-4 flex flex-col gap-2 rounded-2xl border border-white/10 bg-[#111a27] p-3 font-medium shadow-xl md:mt-0 md:flex-row md:items-center md:gap-3 md:border-0 md:bg-transparent md:p-0 md:shadow-none"
        >
          <li v-for="item in menuItems" :key="item.name">
            <router-link
              :to="{ name: item.name }"
              class="menu-link block rounded-2xl px-4 py-3 text-slate-200 hover:text-white md:rounded-full md:px-4 md:py-2"
              :class="{ active: $route.name === item.name }"
              @click="isDrop = true"
            >
              {{ item.label }}
            </router-link>
          </li>
          <li>
            <span
              @click="openProfilePopup"
              v-if="users"
              class="menu-link block cursor-pointer rounded-2xl px-4 py-3 text-white md:rounded-full md:px-4 md:py-2"
              >{{ users.name }}</span
            >
            <span
              @click="$router.push({ name: 'login' })"
              v-else
              class="menu-link block cursor-pointer rounded-2xl px-4 py-3 text-white md:rounded-full md:px-4 md:py-2"
              >Login</span
            >
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>
<script>
export default {
  data() {
    return {
      isDrop: true,
      menuItems: [
        { name: 'tangtangball', label: '탱탱볼' },
        { name: 'lotto', label: '로또 번호 추천' },
        { name: 'fortuneCookie', label: '포춘 쿠키' },
        { name: 'saju', label: '사주 보기' },
        { name: 'boardList', label: '게시판' },
        { name: 'pointRecharge', label: '포인트 충전' },
        { name: 'messages', label: '쪽지함' },
        { name: 'mypage', label: '마이페이지' },
      ],
    };
  },
  computed: {
    hasStatePoint() {
      return this.$store.state.hasPoint;
    },
    users() {
      return this.$store.state.users;
    },
  },
  methods: {
    goHome() {
      this.$router.push({ name: 'home' });
    },
    openProfilePopup() {
      const route = this.$router.resolve({ name: 'profile' });
      const profileUrl = new URL(route.href, window.location.origin).href;
      const width = 520;
      const height = 680;
      const left = Math.max(0, window.screenX + (window.outerWidth - width) / 2);
      const top = Math.max(0, window.screenY + (window.outerHeight - height) / 2);
      const popup = window.open(
        profileUrl,
        'atozProfile',
        [
          'popup=yes',
          `width=${width}`,
          `height=${height}`,
          `left=${Math.round(left)}`,
          `top=${Math.round(top)}`,
          'resizable=yes',
          'scrollbars=yes',
          'noopener',
          'noreferrer',
        ].join(','),
      );
      if (popup) {
        popup.opener = null;
        popup.focus();
      }
    },
  },
};
</script>
<style scoped>
.site-header {
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  background: linear-gradient(90deg, rgba(8, 15, 26, 0.97), rgba(12, 33, 51, 0.94)), #080f1a;
  box-shadow: 0 18px 60px rgba(0, 0, 0, 0.28);
}

.site-header span:first-child span {
  color: #1ec8ff;
  letter-spacing: -0.04em;
}

.menu-link {
  transition:
    background-color 160ms ease,
    color 160ms ease,
    box-shadow 160ms ease;
}

.menu-link:hover,
.menu-link.active {
  background: rgba(30, 200, 255, 0.15);
  color: #1ec8ff;
  box-shadow: inset 0 0 0 1px rgba(30, 200, 255, 0.28);
}

li > span {
  cursor: pointer;
}
</style>
